// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__12hDU","info":"Note_info__2R7jZ","note":"Note_note__2pC48","actions":"Note_actions__2ZMvW"};